<template>
    <div class="compliance-report-approve-modal">
        <p class="compliance-report-approve-modal__hint">
            {{ $t('§eq_operator.compliance_approve_modal_hint') }}
        </p>

        <CoreTwoColumnsRow class="mb-2">
            <template #left>
                <CoreBorderWrapper class="flex-grow-1 flex-shrink-1 flex-basis-45" :condensed="true">
                    {{ $t('§eq_operator.compliance_validity_period') }}
                </CoreBorderWrapper>
            </template>
            <template #right>
                <CoreDropdown
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    v-model="validityMonths"
                    :options="validityMonthsOptions"
                    :sort="false"
                    :condensed="true"
                />
            </template>
        </CoreTwoColumnsRow>

        <div class="modal-actions">
            <CoreButton
                label="§ui_button.cancel"
                variant="tertiary"
                icon="pi-times"
                @click="closeModal"
            />
            <CoreButton
                label="§ui_button.approve"
                variant="primary"
                icon="pi-check-circle"
                @click="handleConfirm"
            />
        </div>
    </div>
</template>

<script>
import { useModalStore } from '@/stores/modal'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreDropdown from '@/components/core/CoreDropdown.vue'
import CoreButton from '@/components/core/CoreButton.vue'

// How long the approved check stays valid. Mirrors ComplianceReport::VALIDITY_MONTHS_OPTIONS.
const VALIDITY_MONTHS_OPTIONS = [
    { value: 12, label: '§eq_operator.compliance_validity_12_months' },
    { value: 18, label: '§eq_operator.compliance_validity_18_months' },
    { value: 24, label: '§eq_operator.compliance_validity_24_months' },
    { value: 36, label: '§eq_operator.compliance_validity_36_months' },
]

export default {
    name: 'ComplianceReportApproveModal',

    components: {
        CoreTwoColumnsRow,
        CoreBorderWrapper,
        CoreDropdown,
        CoreButton,
    },

    data() {
        return {
            validityMonths: 12,
            modalStore: useModalStore(),
        }
    },

    computed: {
        validityMonthsOptions() {
            return VALIDITY_MONTHS_OPTIONS
        },
    },

    methods: {
        closeModal() {
            this.modalStore.setClose()
        },

        // The view owns the request, its toast and the spinner on the approve button.
        handleConfirm() {
            this.modalStore.data.onConfirm(this.validityMonths)
            this.closeModal()
        },
    },
}
</script>

<style scoped>
.compliance-report-approve-modal {
    padding: 40px;
}

.compliance-report-approve-modal__hint {
    margin: 0 0 1.5rem 0;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
}
</style>
